import * as React from 'react'

import { Radio } from '@factorialco/deprecated-design-system'

import { getCopies } from 'modules/contracts/components/FlowSelectorModal/utils'

import FixRadioOption from 'modules/contracts/components/FlowSelectorModal/RadioOptions/FixRadioOption'
import PromoteRadioOption from 'modules/contracts/components/FlowSelectorModal/RadioOptions/PromoteRadioOption'
import UpdateRadioOption from 'modules/contracts/components/FlowSelectorModal/RadioOptions/UpdateRadioOption'

interface Props {
  showFixOption: boolean
  employeeFullName: string
  value: string
  onChange: (option: React.SetStateAction<string>) => void
  canPromote: boolean
  canEdit: boolean
}

const OngoingModalContent = ({
  showFixOption,
  employeeFullName,
  value,
  onChange,
  canPromote,
  canEdit,
}: Props) => {
  const copies = getCopies(employeeFullName)

  return (
    <>
      {canPromote && (
        <Radio.Wrap>
          <PromoteRadioOption title={copies.promote} value={value} onChange={onChange} />
        </Radio.Wrap>
      )}
      {canEdit && (
        <Radio.Wrap>
          <UpdateRadioOption title={copies.update} value={value} onChange={onChange} />
        </Radio.Wrap>
      )}
      {canEdit && showFixOption && (
        <Radio.Wrap>
          <FixRadioOption title={copies.fix} value={value} onChange={onChange} />
        </Radio.Wrap>
      )}
    </>
  )
}

export default OngoingModalContent
